<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import LogoLight from '/public/images/logos/snapei-b2b-logo-light.svg';
</script>
<template>
    <div class="logo">
        <NuxtLink to="/">
            <VImg :src="LogoLight"  :height="`${$attrs.height ?? 60}`" :width="`${$attrs.width ?? 230}`" v-bind="$attrs" >
            </VImg>
        </NuxtLink>
    </div>
</template>
